<div class="raw main">
    <div class="col-12 reserve">
        <div class="tab">
            <label routerLink="/member/reserve">完成預約</label>
            <label routerLink="/member/history">歷史報名資料</label>
            <label class="active">主要產品維護</label>
        </div>
      
        
        <div class="edit col-12">
            <!-- <div class="col-3 editlist">
                <p class="note">聯絡人</p>
                <ul>
                    <ng-container *ngFor="let item of Data;let _index = index;">
                        <li (click)="SetMember(item)">{{item.name}} {{item.englishName}}</li>
                    </ng-container>
                    <li (click)="Reset()">新增聯絡人...</li>
                </ul>
            </div> -->
            <div class="col-6 signup">
                <p class="note">資料修改</p>
                <form [formGroup]="mainForm" (ngSubmit)="FormSubmit()">
        
                    <h3 *ngIf="IsEdit">公司資訊</h3>
                    <div class="form" *ngIf="IsEdit">
                        <div class="form-group">
                            <label  class="require">公司網址</label>
                            <input type="text" class="fullwidth" formControlName="url" placeholder="請輸入公司網址" maxlength="250"/>
                            <span class="help-block" *ngIf="!(mainForm.get('url').valid || mainForm.get('url').pristine)">
                                必填，限250字以內
                            </span>
                        </div>
                        <label class="require">主要產品(中文)</label>
                        <textarea formControlName="product" maxlength="500"></textarea>
                        <span class="count">{{mainForm.value['product'].length}}/500</span>
                        <span class="help-block" *ngIf="!(mainForm.get('product').valid || mainForm.get('product').pristine)">
                            必填，限500字以內
                        </span>
        
                        <label class="require">主要產品(英文)</label>
                        <textarea formControlName="productEn" maxlength="1000"></textarea>
                        <span class="count">{{mainForm.value['productEn'].length}}/1000</span>
                        <span class="help-block" *ngIf="!(mainForm.get('productEn').valid || mainForm.get('productEn').pristine)">
                            必填，限500字以內
                        </span>
                    </div>

                    <div class="btn {{!mainForm.valid ? 'disabled' : ''}}" (click)="FormSubmit()">確認送出</div>
                </form>
            </div>
        </div>

    </div>
</div>
